import { PharmacyLocationSearchForm } from "../Components/Forms";
import { PharmacyLocationSearchPageProps } from "../types";
import { PharmacyLocationResultsTable } from "../Components/PharmacyLocations";

const PharmacyLocationSearchPage = ({
    pharmacies,
    pageState,
}: PharmacyLocationSearchPageProps) => {
    return (
        <>
            <PharmacyLocationSearchForm pageState={pageState} />

            {pharmacies && (
                <div className="w-full">
                    <PharmacyLocationResultsTable pharmacies={pharmacies} />
                </div>
            )}
        </>
    );
};

export default PharmacyLocationSearchPage;
